import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrangeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23.3496 16.3955L17.4726 4.4683C17.2206 3.9556 16.3788 3.9556 16.1269 4.4683L15.6533 5.4294C14.5525 3.194 12.2558 1.6499 9.6 1.6499C5.8778 1.6499 2.85 4.6777 2.85 8.3999C2.85 9.2987 3.0302 10.1551 3.3505 10.9401L1.4701 11.8594C1.2128 11.9854 1.0497 12.2466 1.0497 12.5332V19.8672C1.0497 20.1533 1.2128 20.4151 1.4706 20.541L7.4706 23.4736C7.5741 23.5244 7.6869 23.5498 7.7997 23.5498C7.9125 23.5498 8.0253 23.5244 8.1288 23.4736L14.1288 20.541C14.3866 20.415 14.5497 20.1533 14.5497 19.8672V19.814C15.2635 19.894 16.0097 19.9502 16.7997 19.9502C19.1366 19.9502 21.2636 19.584 22.4882 18.9717C23.4306 18.501 23.8174 17.3457 23.3496 16.3955ZM4.3501 8.3999C4.3501 5.5049 6.7051 3.1499 9.6001 3.1499C12.118 3.1499 14.2239 4.9335 14.7302 7.3029L12.8042 11.2117L8.1294 8.9262C7.9214 8.8246 7.6782 8.8246 7.4702 8.9262L4.7202 10.2706C4.4888 9.6895 4.3501 9.0632 4.3501 8.3999ZM8.2852 15.3945C8.2798 15.3586 8.2769 15.3232 8.264 15.2894C8.2523 15.2588 8.2333 15.2336 8.2161 15.2061C8.1993 15.179 8.1853 15.1513 8.1632 15.1277C8.1383 15.101 8.1074 15.0825 8.0771 15.0617C8.0569 15.0478 8.0421 15.0286 8.0194 15.0175L3.2224 12.6721L7.7997 10.435L13.0497 13.0009V19.3993L8.2997 21.7204V15.4667C8.2997 15.4411 8.2889 15.4191 8.2852 15.3945ZM2.5498 13.4565L7.2998 15.7789V21.7204L2.5498 19.3993V13.4565ZM21.8184 17.6299C20.8057 18.1358 18.8829 18.4502 16.7998 18.4502C16.0041 18.4502 15.256 18.3903 14.5498 18.305V12.5332C14.5498 12.2553 14.3945 12.0037 14.1501 11.8737L16.7998 6.4966L22.0039 17.0576C22.1103 17.2734 22.0283 17.5244 21.8184 17.6299Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrangeIcon.displayName = 'ArrangeIcon';
